import {useSelector} from "react-redux";

export default function () {
    const htmlBody = useSelector(state => state.dispatcher.htmlBody);
    const loadingHtmlBody = useSelector(state => state.dispatcher.loading);
    return { htmlBody, loadingHtmlBody };
}